import { render, staticRenderFns } from "./D203.vue?vue&type=template&id=2317de7f&scoped=true"
import script from "./D203.vue?vue&type=script&lang=js"
export * from "./D203.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=2317de7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317de7f",
  null
  
)

export default component.exports